import lodash from 'lodash'

import {
  IOrderEntryAddress,
  IOrderEntryPreset,
  TOrderEntryFormValues,
} from '../types'

function trimAddress(
  address: IOrderEntryAddress | undefined,
): Partial<IOrderEntryAddress> | undefined {
  if (!address) {
    return undefined
  }
  return lodash.pickBy(address, (p) => p && p !== '')
}

/**
 * Tweak some initial values
 */
export default function fixInitialValues(
  values: TOrderEntryFormValues,
  {
    preset,
    currentCustomer,
  }: { preset: IOrderEntryPreset | null; currentCustomer: object | null },
): TOrderEntryFormValues {
  const {} = preset ?? {}
  const { pickup, customer } = values ?? {}

  // auto set isEdit to pickup if pickup address is diverging from customer address
  const isPickupAddressDifferent = !lodash.isEqual(
    trimAddress(lodash.get(pickup, 'address')),
    trimAddress(lodash.get(customer, 'address')),
  )
  return {
    ...values,
    pickup: {
      ...pickup,
      isEdit: pickup.isEdit, // || isPickupAddressDifferent,
    },
  }
}
